"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.titleStyle = void 0;
exports.titleStyle = {
    fontSize: '15px',
    fontFamily: 'Inter',
    fontWeight: '500',
    color: '#333'
};
